// Central registry of responsive image variants powered by vite-imagetools.
// Each entry provides AVIF + WebP + JPEG srcsets, a JPEG fallback and a tiny
// blurred LQIP placeholder for instant visual feedback while the full image loads.
// SEO-friendly source filenames; vite-imagetools re-encodes at build time.
// Aggressive quality tuning + narrower max widths for fast LCP.

const AVIF = "format=avif&quality=42&effort=6";
const WEBP = "format=webp&quality=62";
const JPEG = "format=jpeg&quality=68&mozjpeg";
const WIDTHS = "w=480;768;1200";
const FALLBACK_W = "w=1200";

import heroMoleculeAvif from "@/assets/retatrutid-molekuel-triple-agonist.jpg?w=480;768;1200;1600&format=avif&quality=42&effort=6&as=srcset";
import heroMoleculeWebp from "@/assets/retatrutid-molekuel-triple-agonist.jpg?w=480;768;1200;1600&format=webp&quality=62&as=srcset";
import heroMoleculeJpg from "@/assets/retatrutid-molekuel-triple-agonist.jpg?w=480;768;1200;1600&quality=68&mozjpeg&format=jpeg&as=srcset";
import heroMoleculeFallback from "@/assets/retatrutid-molekuel-triple-agonist.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import heroMoleculePlaceholder from "@/assets/retatrutid-molekuel-triple-agonist.jpg?w=40&quality=20&format=jpeg&inline";

import comparisonBarsAvif from "@/assets/retatrutid-wirkstoff-vergleich-glp1.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import comparisonBarsWebp from "@/assets/retatrutid-wirkstoff-vergleich-glp1.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import comparisonBarsJpg from "@/assets/retatrutid-wirkstoff-vergleich-glp1.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import comparisonBarsFallback from "@/assets/retatrutid-wirkstoff-vergleich-glp1.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import comparisonBarsPlaceholder from "@/assets/retatrutid-wirkstoff-vergleich-glp1.jpg?w=40&quality=20&format=jpeg&inline";

import thailandClinicAvif from "@/assets/retatrutid-klinik-bangkok-thailand.jpg?w=480;768;1200;1600&format=avif&quality=42&effort=6&as=srcset";
import thailandClinicWebp from "@/assets/retatrutid-klinik-bangkok-thailand.jpg?w=480;768;1200;1600&format=webp&quality=62&as=srcset";
import thailandClinicJpg from "@/assets/retatrutid-klinik-bangkok-thailand.jpg?w=480;768;1200;1600&quality=68&mozjpeg&format=jpeg&as=srcset";
import thailandClinicFallback from "@/assets/retatrutid-klinik-bangkok-thailand.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import thailandClinicPlaceholder from "@/assets/retatrutid-klinik-bangkok-thailand.jpg?w=40&quality=20&format=jpeg&inline";

import safetyVialAvif from "@/assets/retatrutid-ampulle-sicherheit.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import safetyVialWebp from "@/assets/retatrutid-ampulle-sicherheit.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import safetyVialJpg from "@/assets/retatrutid-ampulle-sicherheit.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import safetyVialFallback from "@/assets/retatrutid-ampulle-sicherheit.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import safetyVialPlaceholder from "@/assets/retatrutid-ampulle-sicherheit.jpg?w=40&quality=20&format=jpeg&inline";

import scienceAbstractAvif from "@/assets/retatrutid-wissenschaft-rezeptoren.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import scienceAbstractWebp from "@/assets/retatrutid-wissenschaft-rezeptoren.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import scienceAbstractJpg from "@/assets/retatrutid-wissenschaft-rezeptoren.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import scienceAbstractFallback from "@/assets/retatrutid-wissenschaft-rezeptoren.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import scienceAbstractPlaceholder from "@/assets/retatrutid-wissenschaft-rezeptoren.jpg?w=40&quality=20&format=jpeg&inline";

import consultationAvif from "@/assets/retatrutid-aerztliche-beratung.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import consultationWebp from "@/assets/retatrutid-aerztliche-beratung.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import consultationJpg from "@/assets/retatrutid-aerztliche-beratung.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import consultationFallback from "@/assets/retatrutid-aerztliche-beratung.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import consultationPlaceholder from "@/assets/retatrutid-aerztliche-beratung.jpg?w=40&quality=20&format=jpeg&inline";

import lifestyleAvif from "@/assets/retatrutid-erfolg-lifestyle.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import lifestyleWebp from "@/assets/retatrutid-erfolg-lifestyle.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import lifestyleJpg from "@/assets/retatrutid-erfolg-lifestyle.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import lifestyleFallback from "@/assets/retatrutid-erfolg-lifestyle.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import lifestylePlaceholder from "@/assets/retatrutid-erfolg-lifestyle.jpg?w=40&quality=20&format=jpeg&inline";

import conciergeAvif from "@/assets/retatrutid-persoenliche-betreuung-deutsch.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import conciergeWebp from "@/assets/retatrutid-persoenliche-betreuung-deutsch.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import conciergeJpg from "@/assets/retatrutid-persoenliche-betreuung-deutsch.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import conciergeFallback from "@/assets/retatrutid-persoenliche-betreuung-deutsch.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import conciergePlaceholder from "@/assets/retatrutid-persoenliche-betreuung-deutsch.jpg?w=40&quality=20&format=jpeg&inline";

import packageAvif from "@/assets/retatrutid-behandlungspaket-bangkok.jpg?w=480;768;1200&format=avif&quality=42&effort=6&as=srcset";
import packageWebp from "@/assets/retatrutid-behandlungspaket-bangkok.jpg?w=480;768;1200&format=webp&quality=62&as=srcset";
import packageJpg from "@/assets/retatrutid-behandlungspaket-bangkok.jpg?w=480;768;1200&quality=68&mozjpeg&format=jpeg&as=srcset";
import packageFallback from "@/assets/retatrutid-behandlungspaket-bangkok.jpg?w=1200&quality=68&mozjpeg&format=jpeg";
import packagePlaceholder from "@/assets/retatrutid-behandlungspaket-bangkok.jpg?w=40&quality=20&format=jpeg&inline";

import retaVsOzempicDeAvif from "@/assets/retatrutid-vs-ozempic-vergleich-studien.jpg?w=480;768;1122&format=avif&quality=42&effort=6&as=srcset";
import retaVsOzempicDeWebp from "@/assets/retatrutid-vs-ozempic-vergleich-studien.jpg?w=480;768;1122&format=webp&quality=62&as=srcset";
import retaVsOzempicDeJpg from "@/assets/retatrutid-vs-ozempic-vergleich-studien.jpg?w=480;768;1122&quality=68&mozjpeg&format=jpeg&as=srcset";
import retaVsOzempicDeFallback from "@/assets/retatrutid-vs-ozempic-vergleich-studien.jpg?w=1122&quality=68&mozjpeg&format=jpeg";
import retaVsOzempicDePlaceholder from "@/assets/retatrutid-vs-ozempic-vergleich-studien.jpg?w=40&quality=20&format=jpeg&inline";

import retaVsOzempicEnAvif from "@/assets/retatrutide-vs-ozempic-comparison-studies.jpg?w=480;768;1122&format=avif&quality=42&effort=6&as=srcset";
import retaVsOzempicEnWebp from "@/assets/retatrutide-vs-ozempic-comparison-studies.jpg?w=480;768;1122&format=webp&quality=62&as=srcset";
import retaVsOzempicEnJpg from "@/assets/retatrutide-vs-ozempic-comparison-studies.jpg?w=480;768;1122&quality=68&mozjpeg&format=jpeg&as=srcset";
import retaVsOzempicEnFallback from "@/assets/retatrutide-vs-ozempic-comparison-studies.jpg?w=1122&quality=68&mozjpeg&format=jpeg";
import retaVsOzempicEnPlaceholder from "@/assets/retatrutide-vs-ozempic-comparison-studies.jpg?w=40&quality=20&format=jpeg&inline";

export interface ResponsiveImage {
  src: string;
  srcSetAvif: string;
  srcSetWebp: string;
  srcSet: string;
  placeholder: string;
  width: number;
  height: number;
  sizes: string;
}

export const heroMoleculeImage: ResponsiveImage = {
  src: heroMoleculeFallback,
  srcSetAvif: heroMoleculeAvif,
  srcSetWebp: heroMoleculeWebp,
  srcSet: heroMoleculeJpg,
  placeholder: heroMoleculePlaceholder,
  width: 1600,
  height: 906,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const comparisonBarsImage: ResponsiveImage = {
  src: comparisonBarsFallback,
  srcSetAvif: comparisonBarsAvif,
  srcSetWebp: comparisonBarsWebp,
  srcSet: comparisonBarsJpg,
  placeholder: comparisonBarsPlaceholder,
  width: 1200,
  height: 684,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const thailandClinicImage: ResponsiveImage = {
  src: thailandClinicFallback,
  srcSetAvif: thailandClinicAvif,
  srcSetWebp: thailandClinicWebp,
  srcSet: thailandClinicJpg,
  placeholder: thailandClinicPlaceholder,
  width: 1600,
  height: 906,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const safetyVialImage: ResponsiveImage = {
  src: safetyVialFallback,
  srcSetAvif: safetyVialAvif,
  srcSetWebp: safetyVialWebp,
  srcSet: safetyVialJpg,
  placeholder: safetyVialPlaceholder,
  width: 1200,
  height: 756,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const scienceAbstractImage: ResponsiveImage = {
  src: scienceAbstractFallback,
  srcSetAvif: scienceAbstractAvif,
  srcSetWebp: scienceAbstractWebp,
  srcSet: scienceAbstractJpg,
  placeholder: scienceAbstractPlaceholder,
  width: 1200,
  height: 684,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const consultationImage: ResponsiveImage = {
  src: consultationFallback,
  srcSetAvif: consultationAvif,
  srcSetWebp: consultationWebp,
  srcSet: consultationJpg,
  placeholder: consultationPlaceholder,
  width: 1200,
  height: 684,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const lifestyleImage: ResponsiveImage = {
  src: lifestyleFallback,
  srcSetAvif: lifestyleAvif,
  srcSetWebp: lifestyleWebp,
  srcSet: lifestyleJpg,
  placeholder: lifestylePlaceholder,
  width: 1200,
  height: 675,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const conciergeImage: ResponsiveImage = {
  src: conciergeFallback,
  srcSetAvif: conciergeAvif,
  srcSetWebp: conciergeWebp,
  srcSet: conciergeJpg,
  placeholder: conciergePlaceholder,
  width: 1200,
  height: 675,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const packageImage: ResponsiveImage = {
  src: packageFallback,
  srcSetAvif: packageAvif,
  srcSetWebp: packageWebp,
  srcSet: packageJpg,
  placeholder: packagePlaceholder,
  width: 1200,
  height: 675,
  sizes: "(min-width: 1280px) 1200px, (min-width: 768px) 90vw, 100vw",
};

export const retaVsOzempicDeImage: ResponsiveImage = {
  src: retaVsOzempicDeFallback,
  srcSetAvif: retaVsOzempicDeAvif,
  srcSetWebp: retaVsOzempicDeWebp,
  srcSet: retaVsOzempicDeJpg,
  placeholder: retaVsOzempicDePlaceholder,
  width: 1122,
  height: 1402,
  sizes: "(min-width: 1024px) 700px, (min-width: 768px) 80vw, 100vw",
};

export const retaVsOzempicEnImage: ResponsiveImage = {
  src: retaVsOzempicEnFallback,
  srcSetAvif: retaVsOzempicEnAvif,
  srcSetWebp: retaVsOzempicEnWebp,
  srcSet: retaVsOzempicEnJpg,
  placeholder: retaVsOzempicEnPlaceholder,
  width: 1122,
  height: 1402,
  sizes: "(min-width: 1024px) 700px, (min-width: 768px) 80vw, 100vw",
};
